import { useState } from "react";

import { ContactInbox } from "./ContactInbox.jsx";
import { CONTENT_CONFIGS } from "./contentConfigs.js";
import { ContentManager } from "./ContentManager.jsx";
import { Subscribers } from "./Subscribers.jsx";
import { WebsiteEditor } from "./WebsiteEditor.jsx";

const SUBTABS = [
  ["pages", "Pages"],
  ["team", "Team"],
  ["sponsors", "Sponsors"],
  ["packages", "Packages"],
  ["resources", "Resources"],
  ["posts", "News"],
  ["gallery", "Gallery"],
  ["faqs", "FAQ"],
  ["speakers", "Speakers"],
  ["jobs", "Jobs"],
  ["messages", "Messages"],
  ["subscribers", "Subscribers"],
];

export function WebsiteHub({ chapterId, slug, canManage, isAdmin, onGoToTeam }) {
  const [sub, setSub] = useState("pages");

  return (
    <>
      <nav className="subtabs">
        {SUBTABS.map(([key, label]) => (
          <button key={key} className={key === sub ? "active" : ""} onClick={() => setSub(key)} type="button">
            {label}
          </button>
        ))}
      </nav>
      {sub === "pages" && <WebsiteEditor chapterId={chapterId} slug={slug} canManage={canManage} isAdmin={isAdmin} />}
      {sub === "team" && (
        <p className="muted">
          The public "Meet the Team" list is your board roster (with photos &amp; bios).{" "}
          <button className="link-btn" type="button" onClick={onGoToTeam}>Manage it on the Overview tab →</button>
        </p>
      )}
      {sub === "messages" && <ContactInbox chapterId={chapterId} canManage={canManage} />}
      {sub === "subscribers" && <Subscribers chapterId={chapterId} canManage={canManage} />}
      {CONTENT_CONFIGS[sub] && <ContentManager chapterId={chapterId} config={CONTENT_CONFIGS[sub]} canManage={canManage} />}
    </>
  );
}
